// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3V7Gr","header":"ClearentDisclaimer_header__3MmF8","inner":"ClearentDisclaimer_inner__3nSNo"};